import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';

type ChannelPropsType = {
	number: string;
	info: React.ReactNode;
	graph: React.ReactNode;
};

const Channel: React.FC<ChannelPropsType> = ({
	number,
	info,
	graph,
}) => {
	const { t } = useTranslation();
	return (
		<>
			<div className={Styles.infoContainer}>
				<div>
					<h2>{number}</h2>
					<p>{t("KLR02585")}</p>
				</div>
				<div className={Styles.detailContainer}>{info}</div>
			</div>
			<div className={Styles.graphContainer}>{graph}</div>
		</>
	)
}

export default Channel;
